/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var LOG = require('logger').getLogger('product.base');

var $ = window.jQuery = require('base'), _api = module.exports;

$.extend(_api, require('../common/com.jufeng.common.header'));

_api.qtip = $.Deferred();

// util.number
_api.number_util = $.Deferred();
// layer
_api.layer = $.Deferred();

// 后台修改订单
_api.init_4_back_mdf_order = function () {
	var mdf_token = $('input[name="mdf_token"]').val();
	var order_no = $('input[name="order_no"]').val();
	if (mdf_token && order_no) {
		$('.buy_btn_big').hide();
		$('.cart_btn_big').html('<i class="icon-basket "></i>加到订单');
	}
}

_api.context.done(function (context) {
	// 购买按钮事件绑定
	$('#product_main').on('click', '.buy_toolbar_box .btn_multi_right', function (e) {
		var btn = $(e.target).is('a') ? $(e.target) : $(e.target).closest('a');
		var add_type = btn.is('.buy_btn_big') ? 1 : 0;
		var seckill = +btn.data('seckill') === 1 ? true : false;
		var model = _api.before_add2cart();
		if (model) {
			var mdf_token = $('input[name="mdf_token"]').val();
			var order_no = $('input[name="order_no"]').val();
			if (mdf_token && order_no) {
				$.ajax({
					type : 'post',
					url : '/add2order.htm?order_no=' + order_no + "&mdf_token=" + mdf_token,
					dataType : 'json',
					contentType : 'application/json',
					data : JSON.stringify(model)
				}).done(function (tip) {
					var msg = tip.msg || '';
					layer.alert(msg, {
						title : '温馨提示',
						icon : 1,
						time : 5000,
						end : function () {
							if (window.opener && $.isFunction(window.opener.postMessage)) {
								window.opener.postMessage('reload', '*');
							}
						}
					});
				});
			} else {
				// 标示为秒杀产品.
				model.seckill = seckill;
				// 如果是秒杀产品，则需要判断是否超过单个账号限购数量
				seckill_check(model).done(function () {
					if (!model.price) {
						var sum = 0;
						for (var detail in model.cart_details) {
							sum += model.cart_details[detail].price || 0;
						}
						model.price = sum;
					}
					var pay_type = model.pay_type;
					// 如果是授信方式购买检查授信余额是否足够
					if (pay_type > 0) {
						context.check_credit_line(model.pay_type, model.price, $.proxy(_add_2_cart, null, model, add_type))
					} else {
						// reviewed by liwencheng 2016-03-03
						context.try_login(function () {
							
							$.ajax({
								type : 'post',
								url : '/pro_common/getMemberPrice.htm?product_no=' + model.product_no +"&seckill="+model.seckill,
								dataType : 'json',
								contentType : 'application/json',
							}).done(function (tip) {
								console.log(tip);
								console.log(tip.price);
								//目前先处理板材的
								if (tip.price) {
									if (model.product_no == '8090130010041' || model.product_no == '8090130010036') {
										_api.reload(tip.price);
										model = _api.before_add2cart();
										model.seckill = seckill;
									}
								} 
								// // 如果当前产品支持15天到货，且当前支付方式为现金
								if (model.fifteen_days_supported === 'true' && model.pay_type == 0) {
									$.ajax({
										url : '/prod/check_delivery.htm?product_no=' + model.product_no + '&price=' + model.price + '&seckill=' + (+model.seckill),
										success : function (content) {
											$.when(_api.number_util, _api.layer).then(function (number_util, layer) {
												layer.open({
													title : '',
													type : 1,
													area : ['auto', 'auto'], // 宽高
													shadeClose : true,
													scrollbar : true,
													content : content,
													success : function (layero, index) {
														require.ensure('../vendor/com.jufeng.checkbox', function () {
															require('../vendor/com.jufeng.checkbox');
															$('.term_radio input', layero).bindCheckboxRadioSimulate();
														});
														$(".J_fifteen_ok").click(function () {
															if ($(this).attr('fifteen_days')) {
																model.fifteen_days = true;
															} else {
																model.fifteen_days = $('input[name="fifteen_days"]:checked').val()
															}
															layer.closeAll();
															_add_2_cart(model, add_type, {
																result : 'success'
															});
														});
														$(".J_fifteen_cancel").click(function () {
															if ($(this).attr('fifteen_days')) {
																model.fifteen_days = true;
															}  else {
																model.fifteen_days = false;
															}
															layer.closeAll();
															_add_2_cart(model, add_type, {
																result : 'success'
															});
														});
													}
												});
											})
										}
									})
								} else {
									_add_2_cart(model, add_type, {
										result : 'success'
									});
								}
							});	
							
						})
					}
				}).fail(function (limit) {
					layer.alert('请不要超过单个会员最高限购量:' + limit, {
						title : '温馨提示',
						icon : 5,
						time : 1500
					})
				})
			}
		}
	})
})

require.ensure('jqzoom', function () {
	require('jqzoom');
});

require.ensure('jquery.nav', function () {
	require('jquery.nav');
	$('#floor_right').onePageNav({
		scrollThreshold : 0.1,
		filter : ':not(.dowebok)'
	});
});

require.ensure('../bootstrap/button', function () {
	require('../bootstrap/button')
})

require.ensure('qtip2', function () {
	_api.qtip.resolve(require('qtip2'));
})

_api.qtip.done(_default_init_qtip_callback);

/**
 * 默认的qtip绑定回调函数.
 */
function _default_init_qtip_callback() {
	_api.init_qtip();
	// 所有的input且有data-tip的不允许输入非数字
	$('#product_main').on('keyup', 'input[data-tip]', function (e) {
		var self = $(this);
		var value = self.val();
		_api.number_util.done(function (number_util) {
			if (self.is('[float]')) {
				if (!number_util.isFloat(value)) {
					self.trigger({
						type : 'error',
						content : '请输入两位小数的数字'
					});
					self.val(number_util.parseFloat(value))
				}
			} else {
				if (/[\D]+/.test(value)) {
					self.trigger({
						type : 'error',
						content : '请输入数字'
					});
					value = value.replace(/[\D]+/, '', 'g');
				}
				self.val(+value);
			}
		})
	})
}
//
_api._default_init_qtip_callback = _default_init_qtip_callback;
//
_api.init_qtip = function (context) {
	$('[data-tip]', context).each(function () {
		var that = $(this);
		var tip_options = new Function("return " + that.data('tip')).call(this);
		var events = $.map(tip_options, function (t, e) {
				return e;
			})
			that.qtip({
				content : function (e, api) {
					var visible_qtips = $('div[id^="qtip-"].qtip:visible').not('#' + api._id);
					if (visible_qtips.length) {
						setTimeout(function () {
							api.toggle(false, e)
						}, 0)
					} else {
						e.focus !== false && $(this).filter('input[type="text"]').focus().select();
					}
					return tip_options[e.type] || e.content;
				},
				show : events.join(' ') + ' error',
				hide : 'keydown blur',
				position : $.extend({
					viewport : $(window),
					target : (tip_options['target'] && $(tip_options['target'])) || true,
					my : 'bottom center',
					at : 'top center',
				}, tip_options['position']),
				style : 'input_tip1'
			})
	})
}

var default_hooks = {
	'pay_type,delivery_type' : function (el, props) {
		var input_el = $(el).find('a.active').find('input');
		this.value = input_el.val();
		var honourable = input_el.attr('honourable');
		if (honourable === 'true') {
			var prop = {
				prop_path : 'honoured',
				paths : ['honoured'],
				depth : 0,
				name : 'honoured',
				value : true
			}
			props.push(prop);
		}
		return true;
	},
	'cart_details.*.code' : function (el) {
		return $(el).is('input') ? $(el).is('input:checked') : true;
	}
}

var model = _api.model = $.Deferred();
_api.lazyload.done(function () {
	require.ensure('model', function () {
		var deferred = _api.model,
		model_factory = require('model');
		function cur_model() {
			var hooks = $.extend({}, default_hooks, _api.model_hooks);
			var model = model_factory.build_model($('#product_main'), hooks);
			$.isFunction(_api.after_model_build) && _api.after_model_build(model);
			return model;
		}

		var binder = $({});
		$.fn.watching = function (events, callback) {
			var el = $(this),
			_events = events.split(' ');
			$.each(_events, function () {
				var paths = this.split('.').reverse();
				binder.on(paths.join('.'), $.proxy(callback, el));
			})
		}

		var ori_done = deferred.done;
		deferred.done = function (fn, ctx) {
			ori_done($.proxy(fn, ctx, model_factory, cur_model, binder));
		}

		$('#product_main').on('keyup.cascade change.cascade', '[data-prop-path]', function (e) {
			var paths = $(this).data('prop-path').split('.').reverse();
			binder.trigger({
				type : paths.join('.'),
				_$source_evt : e,
				_$trigger : e._$trigger || e.target
			}, [cur_model()]);
		})
		deferred.resolve(model_factory, cur_model, binder);
	})
})

function add_2_cart(model, style, callback) {
	require.ensure('cart', function () {
		var cart = require('cart');
		cart.add_cart(model, style, callback)
	})
}

function _add_2_cart(model, add_type, result) {
	_api.layer.done(function (layer) {
		if (result.result === 'success') {
			// 添加至购物车，
			var tip_loading = layer.load(3, {
					id : 'loading',
					shade : 0.03
				});
			add_2_cart(model, add_type, function (tip) {
				layer.close(tip_loading);
				if (tip.result === 'success') {
					// 如果是立即购买则直接进入购物车结算页面
					if (add_type == 1) {
						window.location.href = '/submit.htm?cartids=' + tip.cartNo;
					} else {
						// 更新迷你购物车.
						if ($('#mini_cart').length) {
							_api.lazyload.done(function (lazyload) {
								$('#mini_cart')[0].loaded = false;
								lazyload.call($('#mini_cart'), _api.update_mini_cart);
							})
						}

						var msg = tip.msg || '成功加入购物车中.';

						layer.confirm(msg, {
							title : '温馨提示',
							icon : 1,
							btn : ['立即结算', '继续购物']
						}, function () {
							LOG.info('进入结算.')
							window.location.href = '/cart.htm';
						}, function (index) {
							layer.close(index)
						});
					}
					// 加入购车成功之后.
					$.isFunction(_api.after_add2cart) && _api.after_add2cart()
				} else {
					layer.msg(tip.msg);
				}
			});
		} else {
			layer.alert(result.msg, {
				title : '温馨提示',
				icon : 5,
				closeBtn : 1,
				shade : [0.3, '#393D49'],
				shadeClose : true,
				btn : ['我要申请', '以后再试']
			}, function (index) {
				layer.close(index);
				LOG.info('跳转至授信申请页面.');
				window.location.href = '/credit/apply.htm';
			}, function (index) {
				layer.close(index)
			})
		}
	})

}

require.ensure('util.number', function () {
	$.extend(_api.number_util, require('util.number'));
	var ori_done = _api.number_util.done;
	_api.number_util.done = function (fn) {
		ori_done($.proxy(fn, _api, _api.number_util));
	}
	_api.number_util.resolve(_api.number_util);
})

require.ensure('layer', function () {
	$.extend(_api.layer, require('layer'));
	var ori_done = _api.layer.done;
	_api.layer.done = function (fn) {
		ori_done($.proxy(fn, _api, _api.layer));
	}
	_api.layer.resolve(_api.layer);
})

// ===================================
// 收藏产品
$(document).on("click", '.jufeng_favorite_btn', function () {
	var $this = $(this),
	product_no = $this.data('product-no');
	_api.context.done(function (context) {
		context.try_login(function () {
			_api.layer.done(function (layer) {
				$.ajax({
					url : '/add2Favorites.htm?product_no=' + product_no + '&opt=add',
					dataType : 'json',
					success : function (tip) {
						if (tip.result === 'success') {
							LOG.info('收藏产品(' + product_no + ')成功.');
						}
						layer.alert(tip.msg, {
							title : '温馨提示',
							icon : tip.result === 'success' ? 1 : 5,
							time : 1500
						})
					}
				})
			})
		})
	})
})
// 获取当前路径参数信息.
var param = require('util.url')(window.location.search), seckill = param.get('seckill', 0), product_no = param.get('product_no', '');
var seckill_deferred = _api.seckill_deferred = $.Deferred(), seckill_end_deferred = _api.seckill_end_deferred = $.Deferred();
// 保存产品编码.
_api.product_no = product_no;
if (seckill == 1 && product_no) {
	// 秒杀
	require.ensure('../seckill/com.jufeng.seckill', function () {
		var deferreds = require('../seckill/com.jufeng.seckill')(product_no);
		//获取产品信息
		$.ajax({
			type : 'get',
			url : '/sec_kill/getProduct.htm?product_no=' + product_no,
			dataType : 'json',
			success : function (info) {
				if (info.result == 'success') {
					deferreds[0].done(function(sign){
						seckill_deferred.resolve(info.product, sign)
					}); //
					deferreds[1].done(function(sign){
						seckill_end_deferred.resolve(info.product, sign);
					});
				} else {
					LOG.error('系统异常，请稍后尝试.')
				}
			}
		})
		
	})
}

// 检查是否超过最大订购量
function seckill_check(model) {
	var deferred = $.Deferred(),
	count = 0;
	$.each(model.cart_details, function () {
		count += this.count
	})
	// 如果是秒杀产品，则需要判断是否超过单个账号限购数量
	if (model.seckill) {
		seckill_deferred.done(function (limit) {
			(limit && count > limit) ? deferred.reject(limit) : deferred.resolve();
		})
	} else {
		deferred.resolve();
	}
	return deferred;
}

$('[data-lazy-path^="/rel_prods.htm?product_no="]').on('loaded', function () {
	require.ensure(['../vendor/jquery.cubeportfolio.min', '../vendor/cb_config'], function () {
		require('../vendor/jquery.cubeportfolio.min');
		require('../vendor/cb_config');
	});
})

require('../css/query.less');
require('../css/bootstrap.css');
require('../css/product/product.less');
require('../css/product/jquery.zoom.css');
require('../css/activity.less');
require('../css/floor_right.less');
require('../css/layer.css');
require('../css/jquery.qtip.min.css');
require('../css/product/jquery.bootstrap-touchspin.css');
require('../css/city-picker.css');
require('../css/select2.css');
require('../css/product/cubeportfolio.css');


require.ensure('../vendor/com.jufeng.baidu.share', function () {
	require('../vendor/com.jufeng.baidu.share');
});



// WEBPACK FOOTER //
// ./src/main/javascript/product/com.jufeng.product.js